/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Canceled_ByInputs */

const en_task_canceled_by = /** @type {(inputs: Task_Canceled_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled by`)
};

const pt_br2_task_canceled_by = /** @type {(inputs: Task_Canceled_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelada por`)
};

/**
* | output |
* | --- |
* | "Canceled by" |
*
* @param {Task_Canceled_ByInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_canceled_by = /** @type {((inputs?: Task_Canceled_ByInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Canceled_ByInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_canceled_by(inputs)
	return pt_br2_task_canceled_by(inputs)
});